// Reine Funktionen für Match-Ereignisse (API-Football-Form: { type, detail, time: { elapsed, extra }, team: { id }, player: { name }, assist: { name } }).
// Seitenregel wie istHeimEvent in der App: Team-Id des Events gegen die Heim-Id.
export const istHeimEvent = (ev, heimTeamId) => ev?.team?.id === heimTeamId

// Zählt als Tor: type "Goal", aber nicht der verschossene Elfmeter (hat ebenfalls type "Goal")
export const zaehltAlsTor = (ev) => ev?.type === 'Goal' && ev.detail !== 'Missed Penalty'

// Tore in zeitlicher Reihenfolge. Ein Eigentor steht in der Ereignisliste beim Spieler, zählt aber für den Gegner.
// Ergebnis: [{ minute, extra, seite: 'heim' | 'gast', spieler, vorlage, art: 'elfmeter' | 'eigentor' | null }]
export function toreAusEvents(events, heimTeamId) {
  if (!Array.isArray(events) || heimTeamId == null) return []
  return events
    .filter(zaehltAlsTor)
    .map((ev, i) => ({ ev, i }))
    .sort((a, b) => ((a.ev.time?.elapsed ?? 0) - (b.ev.time?.elapsed ?? 0)) || a.i - b.i)   // stabil, wie eventsSortiert
    .map(({ ev }) => {
      const eigentor = ev.detail === 'Own Goal'
      const heim = istHeimEvent(ev, heimTeamId) !== eigentor
      return {
        minute: ev.time?.elapsed ?? null, extra: ev.time?.extra ?? null,
        seite: heim ? 'heim' : 'gast',
        spieler: ev.player?.name ?? null, vorlage: ev.assist?.name ?? null,
        art: ev.detail === 'Penalty' ? 'elfmeter' : eigentor ? 'eigentor' : null,
      }
    })
}